/**
 * Design tokens — direct port of the MAFA design system (master_data/app_ui/styles.css).
 *
 * Three palettes only:
 *   • paper/panel/line/ink — the neutral chrome
 *   • accent (teal)        — primary actions and highlights
 *   • alert (amber)        — warnings, conflicts, errors
 *
 * Values are kept as OKLCH strings so they survive a copy/paste round-trip
 * with the CSS variables in src/theme/global.css. Importing them from TS
 * gives us autocomplete and a single source of truth when defining the
 * Mantine theme.
 */
export const colors = {
  paper: 'oklch(0.984 0.005 190)',
  panel: 'oklch(1 0 0)',
  panel2: 'oklch(0.973 0.011 185)',
  panel3: 'oklch(0.962 0.014 184)',
  line: 'oklch(0.922 0.008 196)',
  line2: 'oklch(0.885 0.01 196)',

  ink: 'oklch(0.265 0.018 216)',
  ink2: 'oklch(0.44 0.016 210)',
  ink3: 'oklch(0.605 0.012 205)',
  ink4: 'oklch(0.72 0.01 200)',

  accent: 'oklch(0.605 0.098 182)',
  accent2: 'oklch(0.515 0.092 181)',
  accentInk: 'oklch(0.46 0.082 180)',
  accentTint: 'oklch(0.952 0.024 184)',
  accentTint2: 'oklch(0.915 0.04 183)',
  accentTint3: 'oklch(0.86 0.055 183)',

  alert: 'oklch(0.66 0.125 53)',
  alertInk: 'oklch(0.52 0.125 48)',
  alertTint: 'oklch(0.955 0.028 62)',
  alertTint2: 'oklch(0.9 0.05 60)',
} as const;

export const radius = {
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '22px',
} as const;

export const shadows = {
  sm: '0 1px 2px oklch(0.4 0.03 210 / .06), 0 1px 0 oklch(1 0 0 / .6) inset',
  md: '0 12px 28px -20px oklch(0.35 0.04 210 / .35), 0 1px 0 oklch(1 0 0 / .7) inset',
  lg: '0 30px 70px -38px oklch(0.3 0.04 210 / .42)',
} as const;

export const fonts = {
  sans: '"Plus Jakarta Sans", system-ui, sans-serif',
  mono: '"JetBrains Mono", ui-monospace, monospace',
} as const;
